import { render } from "./EduRegisterDoneView.vue?vue&type=template&id=25fb07e8"
import script from "./EduRegisterDoneView.vue?vue&type=script&lang=js"
export * from "./EduRegisterDoneView.vue?vue&type=script&lang=js"

import exportComponent from "F:\\workspace\\eduwind-front\\eduwind-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__